import * as React from 'react'
  /* @jsx mdx */
import { mdx } from '@mdx-js/react';
/* @jsx mdx */

import DefaultLayout from "/opt/build/repo/www/src/components/mdx/index.tsx";
import { graphql } from 'gatsby';
import { ComponentHeader } from 'components/thumbprint-components';
export const pageQuery = graphql`
    {
        # Get links to by path to display in the navbar.
        platformNav: allSitePage(filter: { path: { glob: "/components/button/*/" } }) {
            edges {
                node {
                    ...PlatformNavFragment
                }
            }
        }
    }
`;
export const _frontmatter = {};

const makeShortcode = name => function MDXDefaultShortcode(props) {
  console.warn("Component " + name + " was not imported, exported, or provided by MDXProvider as global scope");
  return <div {...props} />;
};

const layoutProps = {
  pageQuery,
  _frontmatter
};
const MDXLayout = DefaultLayout;
export default function MDXContent({
  components,
  ...props
}) {
  return <MDXLayout {...layoutProps} {...props} components={components} mdxType="MDXLayout">



    <ComponentHeader data={props.data} mdxType="ComponentHeader" />
    <h3>{`Themes`}</h3>
    <p>{`A button can have one of five themes: Primary, Secondary, Tertiary, Caution and Solid.`}</p>
    <p><img parentName="p" {...{
        "src": "/img/button_states.png",
        "alt": "Button themes",
        "title": "Button themes"
      }}></img></p>
    <h3>{`States`}</h3>
    <p>{`There are three global states: default, active and disabled. The primary button also has a loading state. All active states double as focus states.`}</p>
    <h3>{`Anatomy`}</h3>
    <p><img parentName="p" {...{
        "src": "/img/button_anatomy.png",
        "alt": "Button anatomy",
        "title": "Button anatomy"
      }}></img></p>
    <p>{`Buttons contain one required element and one optional element.`}</p>
    <ol>
      <li parentName="ol"><strong parentName="li">{`Background`}</strong>{`: Buttons are either a solid color or have a 2dp border. All buttons have a 4dp border radius.`}</li>
      <li parentName="ol"><strong parentName="li">{`Content/CTA`}</strong>{` (required): Buttons should be sentence case with exceptions for proper nouns. Buttons should be limited to three words where possible.`}</li>
      <li parentName="ol"><strong parentName="li">{`Icon`}</strong>{` (optional): An icon is used to emphasize an action.`}</li>
    </ol>
    <h3>{`Size`}</h3>
    <p>{`Only one button size is available on native. It adheres to our global tap target of 48dp.`}</p>
    <h3>{`Behavior`}</h3>
    <p>{`By default buttons change width depending on the content inside of them. Occasionally a design requires a button to span the width of the container. Full width buttons occupy 100% of the width available to them in the container.`}</p>
    <p><img parentName="p" {...{
        "src": "/img/button_widths.png",
        "alt": "Button width examples",
        "title": "Button width examples"
      }}></img></p>
    <h3>{`Implementation`}</h3>
    <p><strong parentName="p">{`ThumbprintButton`}</strong></p>
    <p>{`Configurable items (via XML or values):`}</p>
    <ol>
      <li parentName="ol"><inlineCode parentName="li">{`app:buttonType`}</inlineCode>{` in XML or `}<inlineCode parentName="li">{`ThumbprintButton.buttonType`}</inlineCode>{`, with enum values `}<inlineCode parentName="li">{`primary`}</inlineCode>{`, `}<inlineCode parentName="li">{`secondary`}</inlineCode>{`, `}<inlineCode parentName="li">{`tertiary`}</inlineCode>{`, `}<inlineCode parentName="li">{`caution`}</inlineCode>{`, or `}<inlineCode parentName="li">{`solid`}</inlineCode>{`; defaults to `}<inlineCode parentName="li">{`primary`}</inlineCode></li>
      <li parentName="ol"><inlineCode parentName="li">{`android:text`}</inlineCode>{` in XML or `}<inlineCode parentName="li">{`ThumbprintButton.text`}</inlineCode>{`, String`}</li>
      <li parentName="ol"><inlineCode parentName="li">{`app:isEnabled`}</inlineCode>{` in XML or `}<inlineCode parentName="li">{`ThumbprintButton.isEnabled`}</inlineCode>{`, Boolean; defaults to true`}</li>
      <li parentName="ol"><inlineCode parentName="li">{`app:isLoading`}</inlineCode>{` in XML or `}<inlineCode parentName="li">{`ThumbprintButton.isLoading`}</inlineCode>{`, Boolean; defaults to false`}</li>
      <li parentName="ol"><inlineCode parentName="li">{`app:isBleed`}</inlineCode>{` in XML or `}<inlineCode parentName="li">{`ThumbprintButton.isBleed`}</inlineCode>{`, Boolean; defaults to false`}</li>
      <li parentName="ol"><inlineCode parentName="li">{`app:inlineDrawableLeft`}</inlineCode>{` or `}<inlineCode parentName="li">{`app:inlineDrawableRight`}</inlineCode>{` in XML, Drawable`}</li>
    </ol>


    </MDXLayout>;
}
;
MDXContent.isMDXComponent = true;
      